// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Oj2aE","inner":"Footer_inner__3DHic","nextIcon":"Footer_nextIcon__1ly_A","innerLeft":"Footer_innerLeft__12bdR"};